import BaseElements from './components'
import ModulesElements from './modules'
import ViewsElements from './views'

export default function install(Vue) {
  Vue.use(BaseElements)
  Vue.use(ModulesElements)
  Vue.use(ViewsElements)
}
